import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
  className?: string;
};
const units = ['Hours', 'Min', 'Sec'] as const;
export function Countdown({
  tone = 'light',
  className = ''
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const values = [hours, minutes, seconds];
  const isDark = tone === 'dark';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-75" data-mp="3c0b8003ucfy3">
      <p className={`flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.18em] ${isDark ? 'text-gold-light' : 'text-alert'}`} data-id="element-76" data-mp="3h18weufg2681">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="372jckw3zmbp5" />
        This launch offer ends in
      </p>
      <div className="mt-3 flex items-end gap-2" role="timer" aria-live="off" data-id="element-78" data-mp="10clbqjtsw6ag">
        {values.map((value, index) => <React.Fragment key={units[index]} data-id="element-79" data-mp="15adbg00oswp7" data-mpi={index}>
            <div className="flex flex-col items-center" data-id="element-80" data-mp="15928u3iz9uzo">
              <div className={`flex h-16 w-[68px] items-center justify-center rounded-xl border font-display text-3xl font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${isDark ? 'border-gold/40 bg-ink-soft text-gold-light' : 'border-ink/10 bg-ink text-cream'}`} data-id="element-81" data-mp="y0504dv944vs">
                {value}
              </div>
              <span className={`mt-2 text-[10px] font-semibold uppercase tracking-[0.16em] ${isDark ? 'text-cream/60' : 'text-clay'}`} data-id="element-82" data-mp="f2u91gjrwhrf">
                {units[index]}
              </span>
            </div>
            {index < 2 && <span className={`pb-9 font-display text-2xl ${isDark ? 'text-gold/60' : 'text-ink/30'}`} aria-hidden="true" data-id="element-83" data-mp="jzu8v9q14oa3">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}